import { TMP_ELEMENT_POSITION, TMP_ELEMENT_SIZE } from '../../shared/abstract-boxes';

import { getImageCarrouselConfigurationOption } from './imageCarrouselConfiguration';

export function ImageCarrouselBoxViewConstructor(services, callbacks, context, siteTypeConfig) {

  let joint = services.joint;
  let companyId = context.companyId;

  return joint.shapes.html.AbstractBoxElementWithDragAndDropView.extend({
    isElementEditable: true,
    editElementModalController: 'editImageCarrouselElementController',
    editElementModalTemplate: require('./editImageCarrouselElement.modal.html'),
    displayedElementIndex: 0,
    angularTemplate: require('./ImageCarrouselBoxView.html'),
    initialize: function () {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);
    },

    getElementIndexAndTotalElementsAsText: function (elementIndex) {
      if (elementIndex === undefined) {
        elementIndex = this.displayedElementIndex + 1;
      }
      return elementIndex + '/' + this.angularScope.elementData.elements.length;
    },

    getCurrentElementPictureUrl: function () {
      const element = this.getSelectedElementData();
      if (element && typeof element.pictureId === 'number') {
        return services.MediasFactory.pictureUrl(companyId, element.pictureId);
      }
      return '';
    },

    /**
     * Overriden from ElementView because elementData passed to modal is not view elementData but
     * just elementData of selected element
     */
    editElement: function () {
      services.$mdDialog.show({
        controller: this.editElementModalController,
        template: this.editElementModalTemplate,
        locals: {
          'context': context,
          'elementData': angular.copy(this.getSelectedElementData()),
          'elementView': this
        }
      }).then(modalResult => {
        if (modalResult.type === 'ok') {
          this.angularScope.elementData.elements[this.displayedElementIndex] = modalResult.data;
          // to be sure angular detects a change in this.angularScope.elementData
          this.angularScope.elementData = angular.copy(this.angularScope.elementData);
          callbacks.updateSerializedGraph(this.model.graph);
        } else if (modalResult.type === 'delete') {
          this.removeCarrouselElement();
        }
      });
    },

    editImageCarrouselAltText: function() {
      services.$mdDialog.show({
        controller: 'editImageCarrouselAltTextController',
        template: require('./editImageCarrouselAltText.modal.html'),
        locals: {
          'context': context,
          'elementData': angular.copy(this.angularScope.elementData),
          'elementView': this
        }
      }).then(modalResult => {
        if (modalResult.type === 'ok') {
          this.angularScope.elementData.altText = modalResult.data.altText;
          this.angularScope.elementData = angular.copy(this.angularScope.elementData);
          callbacks.updateSerializedGraph(this.model.graph);  
        }
      });
    },

    getSelectedElementData: function () {
      if (this.angularScope.elementData) {
        const elements = this.angularScope.elementData.elements;
        if (this.displayedElementIndex < elements.length) {
          return elements[this.displayedElementIndex];
        }
      }
      return null;
    },

    addCarrouselElement: function () {
      const elements = this.angularScope.elementData.elements;
      let maxElementId = 0;
      for (let element of elements) {
        if (maxElementId < element.carrouselElementId) {
          maxElementId = element.carrouselElementId;
        }
      }
      if (elements.length < this.getConfigurationOption('max-elements')) {
        const newElement = {
          carrouselElementId: maxElementId + 1
        };
        this.displayedElementIndex++;
        elements.splice(this.displayedElementIndex, 0, newElement);
        services.QuickRepliesFactory.createUniqueId(companyId, context.site.id, context.scenarioId)
        .then(response => {
          this.updateButtonsAfterElementsUpdate(response.data.id);
          this.resizeBox();
          this.editElement();
        }, 
        services.AlertingFactory.httpErrorHandler());
      }
    },

    /**
     * Removes the currently displayed carrousel element
     * (if it is not the last element).
     */
    removeCarrouselElement: function () {
      const elements = this.angularScope.elementData.elements;
      if (elements.length > 1) {
        elements.splice(this.displayedElementIndex, 1);
      }
      // to be sure angular detects a change in this.angularScope.elementData
      this.angularScope.elementData = angular.copy(this.angularScope.elementData);
      callbacks.updateSerializedGraph(this.model.graph);
      this.updateButtonsAfterElementsUpdate();
      this.resizeBox();
      this.updateBox();
    },

    /**
     * Switches the currently displayed page to the previous page,
     * if not currently displaying the first page
     */
    previousCarrouselElement: function () {
      if (this.displayedElementIndex > 0) {
        this.displayedElementIndex--;
        this.resizeBoxAfterSetTimeout();
      }
    },

    resizeBoxAfterSetTimeout: function () {
      setTimeout(() => this.resizeBox(), 200);
    },

    /**
     * Switches the currently displayed page to the next page,
     * if not currently displaying the last page
     */
    nextCarrouselElement: function () {
      if (this.displayedElementIndex < this.angularScope.elementData.elements.length - 1) {
        this.displayedElementIndex++;
        this.resizeBoxAfterSetTimeout();
      }
    },

    afterDeserialize: function (shouldResize) {
      this.updateHeadersIndexes();
      if (shouldResize) {
        this.resizeBox();
      }
    },

    /**
     * Updates the text to be displayed by button headers
     * with the index of their 'owner' carrousel element and total number of elements.
     * Needs to be called after inserting or removing a carrousel element.
     */
    updateHeadersIndexes: function () {
      const totalNumber = this.angularScope.elementData.elements.length;
      let i = 1;
      for (let child of this.model.getEmbeddedCells()) {
        if (child.get('type') !== 'html.Next') {
          child.get('elementData').Index = i++;
          child.get('elementData').totalNumber = totalNumber;
        }
      }
    },

    /**
     * Adds/removes a button after adding/removing a carrousel element
     */
    updateButtonsAfterElementsUpdate: function (buttonId = null) {
        // let's reference the box's children before they are unembeded
      const childrenBeforeUpdate = this.model.getEmbeddedCells();
      this.unembedOrRemoveChildren();
      this.reembedChildren(childrenBeforeUpdate, buttonId);
      this.updateHeadersIndexes();
      this.resizeBox();
      if (this.displayedElementIndex >= this.angularScope.elementData.elements.length) {
        this.displayedElementIndex = this.angularScope.elementData.elements.length - 1;
      }
    },


    /*
     * When the carrousel elements have been updated, 
     * all children (buttons and headers)
     * need to either be unembeded to be sorted acording to their corresponding carrousel element,
     * or removed completely if their corresponding carrousel element has been removed
     */
    unembedOrRemoveChildren: function () {
      for (let child of this.model.getEmbeddedCells()) {
        let carrouselElementId = this.childsCarrouselElementId(child);
        if (!carrouselElementId || this.hasElementWithGivenCarrouselElementId(carrouselElementId)) {
          this.model.unembed(child);
        } else {
          child.remove(); // this will remove any outgoing links too
        }
      }
    },

    /**
     * Tells whether our model contains a carrousel element
     * that has the given id
     */
    hasElementWithGivenCarrouselElementId: function (id) {
      let result = false;
      this.angularScope.elementData.elements.forEach(element => {
        if (element.carrouselElementId === id) {
          result = true;
        }
      });
      return result;
    },

    /**
     * Returns the id of the carrousel element to which this child belongs
     * The given child is a button or a button header, 
     * the id is stored in its 'carrouselElementId' model property;
     */
    childsCarrouselElementId(child) {
      if (child.get('type') === 'html.Next') {
        return null;
      }
      return child.get('elementData').carrouselElementId;
    },


    /*
     * For each carrousel element in the model,
     * if we can find a button and a header
     * that have a matching carrouselElementId, 
     * we embed them; otherwise we embed a new header and button.
     */
    reembedChildren: function (childrenBeforeUpdate, buttonId) {
      for (let element of this.angularScope.elementData.elements) {
        const currentElementId = element.carrouselElementId;
        let foundChildren = false;
        for (let child of childrenBeforeUpdate) {
          if (child.get('type') === 'html.Next') {
            this.model.embed(child);
          } else if (this.childsCarrouselElementId(child) === currentElementId) {
            this.model.embed(child);
            foundChildren = true;
          }
        }
        if (!foundChildren) {
          this.addCarrouselElementButton(buttonId, currentElementId);
        }
      }
    },

    addCarrouselElementButton: function (buttonId, carrouselElementId) {
      let button = this.createCarrouselElementButton(buttonId, carrouselElementId);
      this.model.graph.addCell(button);
      this.model.embed(button);
    },
    
    createCarrouselElementButton: function (id,
                                            carrouselElementId,
                                            position = TMP_ELEMENT_POSITION,
                                            size = TMP_ELEMENT_SIZE,
                                            elementData = null) {
      if (!elementData) {
        elementData = {
          type: 'postback',
          carrouselElementId: carrouselElementId
        };
      }
      let button = new joint.shapes.html.ImageCarrouselElementButton({ id, position, size, elementData });

      return button;
    },

    getConfigurationOption: function (key) {
      return getImageCarrouselConfigurationOption(key);
    },

  });
}
